import * as moment from "moment";
import { IUser, UserModel } from "../../modules/auth";

// Interfaz para el modelo de notificación
export interface INotificationModel {
  id?: number;
  user?: IUser;
  user_id?: number;
  level?: string;
  title: string;
  message: string;
  url_access?: string;
  unread?: boolean;
  created?: string; // Ajustado a `string` en lugar de `moment.Moment` para que coincida con la estructura recibida
  modified?: string; // Ajustado a `string` en lugar de `moment.Moment`
}

// Interfaz para el resultado de notificaciones
export interface IResultNotificationModel {
  count: number;
  next: string;
  previous: string;
  results: INotificationModel[];
}

// Clase para manejar el modelo de notificación
export class NotificationModel {
  id?: number;
  user?: UserModel;
  userId?: number;
  level?: string;
  title: string;
  message: string;
  url_access?: string;
  unread?: boolean;
  created?: moment.Moment;
  modified?: moment.Moment;

  constructor() {
    this.level = 'info';
  }

  // Método para crear una instancia de NotificationModel desde un objeto INotificationModel
  static fromObject(notification: INotificationModel): NotificationModel {
    const obj = new NotificationModel();

    obj.id = notification.id;
    // Convierte el usuario solo si existe
    obj.user = notification.user ? UserModel.fromObject(notification.user as IUser) : undefined;
    
    obj.level = notification.level;
    obj.title = notification.title;
    obj.message = notification.message;
    obj.url_access = notification.url_access;
    obj.unread = notification.unread;

    // Convierte las fechas a objetos moment solo si existen
    obj.created = notification.created ? moment(notification.created) : undefined;
    obj.modified = notification.modified ? moment(notification.modified) : undefined;

    return obj;
  }

  // Método para crear un array de NotificationModel desde un array de INotificationModel
  static fromObjectArray(notifications: INotificationModel[]): NotificationModel[] {
    return notifications.map((notification: INotificationModel) => NotificationModel.fromObject(notification));
  }
}

// Clase para manejar el resultado de una lista de notificaciones
export class ResultNotificationModel {
  count: number = 0;
  next: string;
  previous: string;
  results: NotificationModel[] = [];

  constructor() {
    this.count = 0;
  }

  // Método para crear una instancia de ResultNotificationModel desde un objeto IResultNotificationModel
  static fromObject(result: IResultNotificationModel): ResultNotificationModel {
    const obj = new ResultNotificationModel();
    obj.count = result.count | 0;
    obj.next = result.next;
    obj.previous = result.previous;
    obj.results = (result.results && result.results.length > 0) ? NotificationModel.fromObjectArray(result.results) : [];
    return obj;
  }
}
